/*
 * File: AutocompleteInput.tsx
 * Author: Austin Robinson
 * Date Created: 03/08/2025
 * Copyright (c) DrivingDoc 2025
 */
import Autocomplete from '@mui/material/Autocomplete';
import TextField, { StandardTextFieldProps } from '@mui/material/TextField';
import { Controller, useFormContext } from 'react-hook-form';

interface PropTypes extends StandardTextFieldProps {
  name: string;
  label: string;
  options: string[];
}

export default function AutocompleteInput({ name, label, options, ...textFieldProps }: PropTypes) {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <Autocomplete
          ref={field.ref}
          value={field.value ?? ''}
          onBlur={field.onBlur}
          onInputChange={(_event, value) => {
            field.onChange(value);
          }}
          freeSolo
          options={options}
          renderInput={(params) => (
            <TextField
              name={name}
              label={label}
              type="text"
              variant="standard"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              // ref={field.ref}
              // onBlur={field.onBlur}
              // onChange={(event) => {
              //     field.onChange(event.target.value);
              // }}
              {...params}
              {...textFieldProps}
            />
          )}
        />
      )}
    />
  );
}
